import React from 'react';
import { useState, useEffect } from "react";
import { PrismicRichText } from "@prismicio/react";
import HsForms from "../hs-forms";

const QuoteSlider = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg =
        sc.background === "gradient"
        ? "gradient-to-b from-grey-light to-white"
        : sc.background === "grey"
        ? "grey-light"
        : sc.background === "dark grey"
        ? "grey-d"
        : sc.background;

    let layout = sc.layout === "Left" ? "md:flex-row" : "md:flex-row-reverse";

    const anchor = sc.section_title.text.replace(/\s+/g, "-").toLowerCase();

    const [member, setMember] = useState(50000);
    const [form, showForm] = useState(false)

    let quote = ~~(member * 1.75 * 2.08 * 12)
    let finalMember = member * 1
    const handleChange = e => {
        setMember(e.target.value);
        
        const value = e.target.value;
    
        // Push an event to the dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "rangeInputEngagement",
          rangeValue: value,
        });
    
      };
      const handleRangeChange = (event) => {
        const value = event.target.value;
    
        // Push an event to the dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "rangeInputEngagement",
          rangeValue: value,
        });
      };
    const formattedQuote = quote.toLocaleString();
    const formattedMember = finalMember.toLocaleString();
      
      useEffect(() => {
        const slider = document.querySelector(".range");

        const adjustSlider = () => {
        const min = slider.min;
        const max = slider.max;
        const val = ((slider.value - min) * 100) / (max - min);
        
        const fillLeft = "#84bd00";
        const fillRight = "#ccc";
        
        slider.style.background = `linear-gradient(to right, ${fillLeft} ${val}%, ${fillRight} ${val}%`;
        };

        slider.addEventListener("input", adjustSlider);

        adjustSlider();
        

        }, []);

      const toggleForm = () => {
        showForm(true)
      }
      const hideForm = () => {
        showForm(false)
      }

      

    return (
        <section className={"relative bg-" + bg + " " + sc.theme + " " + space} id={anchor}>
            <div className={"wrapper flex flex-col justify-between gap-6 md:gap-24 " + layout}>
            <div className="w-full md:w-1/2 content-side">
                <div className="label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 md:mb-2 text-accessible-green">{sc.label}</div>
                <PrismicRichText field={sc.section_title.richText} />
                <PrismicRichText field={sc.content.richText} />
                {sc.custom_code ? <div dangerouslySetInnerHTML={{ __html: sc.custom_code }} /> : "" }
            </div>

                <div className="quote-slider w-full md:w-1/2 rounded-2xl shadow-2xl pt-10 px-12 bg-white self-start">
                        <div className="text-center mb-6">
                            <div className="text-5xl font-bold mb-1">${formattedQuote}</div>
                            <span>annual pharmacy cost savings</span>
                        </div>
                        <input className="range" type="range" value={member} min="1000" max="300000" step="1000" onChange={handleChange} onMouseUp={handleRangeChange} />
                        <div className="text-center mt-6"><div className="text-3xl font-bold text-green">{formattedMember}</div><span>employees</span></div>
                        <div className="flex justify-center">
                            {form ? '' : <a onClick={toggleForm} className="btn bg-yellow text-lg pr-8 pl-5 relative -bottom-6 border-4 border-white shadow-lg">{sc.text}</a>}
                        </div>
                        {form ? 
                        <div className="pb-2 pt-6">
                            {/* <p className="mt-4 text-2xl font-bold text-teal">Get your estimate</p> */}
                            <HsForms formId={sc.form} />
                            <div className="flex justify-center"><a onClick={hideForm} className="btn-nocarat bg-grey-light !text-grey relative -bottom-7 border-4 border-white shadow-lg !no-underline">Hide form</a></div>
                            
                        </div> 
                        : ''}
                    </div>
                </div>
        </section>
    );
}

export default QuoteSlider;
